import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import BatchesAddLayer from "../../components/Batches/BatchCreation";


const AddBatches = () => {
  return (
    <>
     

        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Batch  </h5><Breadcrumb title="Add Batch" /></div>


        {/* AddUserLayer */}
        <BatchesAddLayer />


    </>
  );
};

export default AddBatches;